import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import _ from 'lodash';

import {
  authErrorsSelector,
  isLoadingSigninSelector,
  loginUser,
  setAuthErrors,
} from 'src/store/auth';
import { isLoadingAdminLoginSelector, loginAdminUser } from 'src/store/adminAuth';

import { CustomButton, CustomInput, CustomLink, PageLoader, WhiteCard } from 'src/components';

import { ROUTE } from 'src/constants';

import './signIn.scss';

export const SignIn = () => {
  const { t } = useTranslation('auth');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const formError = useSelector(authErrorsSelector);
  const isLoadingUserLogin = useSelector(isLoadingSigninSelector);
  const isLoadingAdminLogin = useSelector(isLoadingAdminLoginSelector);

  const isAdminLogin = pathname === ROUTE.ADMIN.LOGIN.MAIN;

  const [formData, setFormData] = useState({
    email: '',
    login: '',
    password: '',
  });

  useEffect(() => {
    dispatch(setAuthErrors({}));
  }, [dispatch]);

  const onChange = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event.target.value }));

      const copiedErrors = _.cloneDeep(formError);

      delete copiedErrors[key];

      dispatch(setAuthErrors(copiedErrors));
    },
    [dispatch, formError],
  );

  const onSubmitForm = useCallback(
    (event) => {
      event.preventDefault();

      if (isAdminLogin) {
        return dispatch(loginAdminUser({ payload: formData, navigate }));
      }

      return dispatch(loginUser({ payload: { ...formData, remember: 1 }, navigate }));
    },
    [dispatch, navigate, formData, isAdminLogin],
  );

  const isLoading = isLoadingAdminLogin || isLoadingUserLogin;

  const inlineAdminStyles = {
    height: '100vh',
    alignItems: 'center',
  };

  return (
    <div className="sign-in" style={isAdminLogin ? inlineAdminStyles : {}}>
      {isLoading ? <PageLoader /> : null}

      <WhiteCard>
        <h2>{t('signIn')}</h2>
        <form className="sign-in__form" onSubmit={onSubmitForm}>
          <CustomInput
            label={!isAdminLogin ? t('login') : t('email')}
            onChange={!isAdminLogin ? onChange('login') : onChange('email')}
            errorMessage={!isAdminLogin ? formError?.login : formError?.email}
          />
          <div className="sign-in__form__password">
            {!isAdminLogin ? (
              <div className="sign-in__form__forgot-password">
                <CustomLink to={ROUTE.AUTH.FORGOT_PASSWORD} title={t('forgotPass')} />
              </div>
            ) : null}

            <CustomInput
              label={t('password')}
              onChange={onChange('password')}
              type="password"
              errorMessage={formError?.password}
            />
          </div>
          <CustomButton title={t('enterAcc')} variant="filled" />

          {!isAdminLogin ? (
            <div className="sign-in__form__footer">
              <span>{t('dontHaveAcc')}</span>
              <span>
                <CustomLink title={t('register')} to={ROUTE.AUTH.SIGN_UP} /> {t('rightNow')}
              </span>
            </div>
          ) : null}
        </form>
      </WhiteCard>
    </div>
  );
};
